import { Injectable } from '@angular/core';
import { ApiConfig } from './config.api';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FaqResourceApi {
  constructor(private httpClient: HttpClient) {
  }

  get(lang) {
    return this.httpClient.get(ApiConfig.baseURL + 'api/faqs?lang=' + lang.toUpperCase(), {headers: ApiConfig.requestOptionsHeader});
  }
}
